import { Cookie, CookieLevel, FredhopperSegment } from '@as-react/common-types';

type CookieCallback = (value: string | null) => void;

type CookieCallbackQueueItem = {
  key: string;
  callback: CookieCallback;
};

type CookieOptions = {
  timeInMs?: number;
  secure?: boolean;
};

export class CookieUtil {
  private static callbackQueue: Array<CookieCallbackQueueItem> = [];

  public static get(key: string): string | null {
    const keyEQ = `${key}=`;
    const cookieArray = document.cookie.split('; ');
    const cookie = cookieArray.find((cookieArrayItem: string) => cookieArrayItem.indexOf(keyEQ) === 0);

    return cookie ? cookie.substring(keyEQ.length) : null;
  }

  public static getByRegexp(key: RegExp): string | null {
    const cookieArray = document.cookie.split('; ');
    const findCookie = cookieArray.find(el => key.test(el));
    const matchedCookie = findCookie && key.exec(findCookie);

    return matchedCookie ? this.get(matchedCookie[0]) : null;
  }

  public static set(key: string, value: string = '', options: CookieOptions = {}): void {
    const { timeInMs, secure } = options;
    let expires = ' ';

    if (timeInMs) {
      const date = new Date();
      date.setTime(date.getTime() + timeInMs);
      expires = ` expires=${date.toUTCString()}; `;
    }

    document.cookie = `${key}=${value};${expires}${secure ? 'secure; ' : ''}path=/`;
    this.fireChange(key, value);
  }

  public static delete(key: string): void {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    this.fireChange(key, null);
  }

  public static addChangeListener(key: string, callback: CookieCallback): void {
    this.callbackQueue.push({
      key,
      callback,
    });
  }

  public static removeChangeListener(key: string, callback: CookieCallback): void {
    this.callbackQueue = this.callbackQueue.filter((item: CookieCallbackQueueItem) => {
      return !(item.key === key && item.callback === callback);
    });
  }

  public static isCookieLevelAcceptAll(): boolean {
    return this.isCookieLevel(CookieLevel.LEVEL_TWO);
  }

  public static getFredhopperSegment(): FredhopperSegment {
    const fredhopperSegment = this.get(Cookie.FREDHOPPER_SEGMENT);

    if (fredhopperSegment) {
      return this.get(Cookie.FREDHOPPER_SEGMENT) as FredhopperSegment;
    } else {
      return FredhopperSegment.A; // Todo: needed ?
    }
  }

  private static fireChange(key: string, value: string | null) {
    this.callbackQueue.forEach((item: CookieCallbackQueueItem) => {
      if (item.key === key) {
        item.callback(value);
      }
    });
  }

  private static getCookieLevel(): number {
    return Number(this.get(Cookie.LEVEL));
  }

  private static isCookieLevel(level: number): boolean {
    return this.getCookieLevel() === level;
  }
}
